export const interpolateString = <T extends string | undefined>(str: T, variables: Record<string, string>): T => {
  return str?.replace(/\{\{(.*?)\}\}/g, (full, match) =>
    variables[match] !== undefined ? variables[match] : full,
  ) as T;
};
